import React, { useState } from "react";
import { toast } from "react-toastify";
import Handler from "../Helpers/Components/Handler";
import { useAuth } from "../Contexts/AuthenticateProvider";

const Admin = () => {
    const [detail, setDetail] = useState({ email: "", password: "", otp: "", setPhone: false, phone: "" });
    const validEmail = new RegExp('([a-z0-9.]{2,})+@([a-z]{3,})+([.]{1})+[a-z]{2,3}')
    const [disable, setDisable] = useState(false)
    const [show, setShow] = useState(false)
    const [otp, setOtp] = useState(false)
    const { logIn } = useAuth()
    const [page, setPage] = useState(false)
    const sendOtp = async () => {
        if (detail?.email === "") {
            toast.error("Email ID is required")
        } else if (!validEmail.test(detail?.email?.toLowerCase())) {
            toast.error("Invalid Email")
        } else if (detail?.password === "") {
            toast.error("Password is required")
        } else {
            setDisable(true)
            const response = await Handler({ method: "post", url: `/auth-admin/signin/send-otp`, data: detail })
            setDisable(false)
            if (response?.success) {
                toast.success("Please check your mobile");
                setDetail((prevValue) => ({ ...prevValue, phone: response?.data }));
                setOtp(true)
                setPage(true)
                setTimeout(() => {
                    setOtp(false)
                }, 20000)
            } else {
                toast.error(response?.message)
            }
        }
    }
    const verifyOtp = async () => {
        if (detail?.otp === "") {
            toast.error("OTP is required")
        } else if (detail?.otp?.length !== 6) {
            toast.error("OTP must be 6 digits")
        } else {
            setDisable(true)
            const response = await Handler({method: "post", url: `/auth-admin/signin/verify-otp`, data: detail})
                if (response?.success) {
                    toast.success(response?.message);
                    logIn(response?.data, "admin")
                } else {
                    setDisable(false)
                    toast.error(response?.message)
                }
        }
    }
    const handleChange = (e) => {
        setDetail((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }));
    }
    const handleKeyUp = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (page) {
                verifyOtp()
            } else {
                sendOtp()
            }
        }
    };
    return (
        <React.Fragment>
            {
                page ?
                    <>
                        <div className="my-3">
                            <label htmlFor="email" className="mb-1"> Email</label>
                            <input disabled autoComplete="off" id="email" name="email" className="form-control input-theme" placeholder="Email Address" onKeyUp={handleKeyUp} value={detail?.email} onChange={handleChange} type="email" />
                        </div>
                        <div className="my-3">
                            <label htmlFor="otp" className="mb-1"> OTP</label>
                            <div className="input-group">
                                <input disabled={disable} autoComplete="off" id="otp" name="otp" className="form-control password-input input-theme" placeholder="OTP" onKeyUp={handleKeyUp} value={detail?.otp || ""} maxLength={6} onChange={(e) => {
                                    if (/^\d{0,}$/.test(e.target.value) || e.target.value === "") {
                                        handleChange(e)
                                    }
                                }} type="text" />
                                <button disabled={otp || disable} className={`${otp || disable ? "disabledBtn " : ""} input-group-text password-icon resend`} id="btn_1" onClick={sendOtp}> Resend OTP</button>
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div className="my-3">
                            <label htmlFor="email" className="mb-1"> Email</label>
                            <input disabled={disable} autoComplete="off" id="email" name="email" className="form-control input-theme" placeholder="Email Address" onKeyUp={handleKeyUp} value={detail?.email} onChange={handleChange} type="email" />
                        </div>
                        <div className="my-3">
                            <label htmlFor="password" className="mb-1"> Password </label>
                            <div className="input-group">
                                <input disabled={disable} autoComplete="off" id="password" name="password" className="form-control input-theme password-input" placeholder="******" onKeyUp={handleKeyUp} value={detail?.password} onChange={handleChange} type={show ? "text" : "password"} />
                                <span className="input-group-text password-icon">{show ? <i className="fa-regular fa-eye-slash cursor-pointer" onClick={() => setShow(!show)}></i> : <i className="fa-regular fa-eye cursor-pointer" onClick={() => setShow(!show)}></i>}</span>
                            </div>
                        </div>
                    </>
            }

            <div className="text-center"><button type="button" className="btn btn-theme mt-2 w-100" disabled={disable} onClick={page ? verifyOtp : sendOtp}>{disable ? <i className="fa-solid fa-spinner fa-spin"></i> : "Login"}</button></div>
        </React.Fragment>
    )
}

export default Admin;